import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkboxes"
export default class extends Controller {
  // static targets = ["form", "price", "endDate"]
  static targets = ["form", "endDate"]

  connect() {
    this.attributeTargets.forEach((attribute) => {
      attribute.addEventListener('input', this.getPrice);
    });

    this.rangeTargets.forEach((range) => {
      range.addEventListener('range-jump', this.getPrice);
    });
  }

  disconnect() {
    this.attributeTargets.forEach((attribute) => {
      attribute.removeEventListener('input', this.getPrice);
    });

    this.rangeTargets.forEach((range) => {
      range.removeEventListener('range-jump', this.getPrice);
    });
  }

  getPrice = (event) => {
    const form = this.formTarget

    form.action.replace('steps/covers', 'get_price_from_form')
    const getPriceForm = form.cloneNode(true);
    getPriceForm.action = form.action.replace('steps/covers', 'get_price_from_form');
    const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

    // Handle form submission asynchronously
    async function submitFormAsync(getPriceForm) {
      try {
        const formData = new FormData(getPriceForm);

        const response = await fetch(getPriceForm.action, {
          method: getPriceForm.method,
          body: formData,
          headers: {
            "X-CSRF-Token": csrfToken
          }
        });

        if (response.ok) {
          // Handle successful response
          const responseData = await response.json();
          updatePriceDisplay(responseData.price)
        } else {
          // Handle error response
          console.error("Form submission failed.");
        }
      } catch (error) {
        console.error("An error occurred during form submission:", error);
      }
    }

    submitFormAsync(getPriceForm);

    const updatePriceDisplay = (price) => {
      const priceDisplayElements = this.priceDisplayTargets;
      priceDisplayElements.forEach((priceDisplayElement) => {
        priceDisplayElement.textContent = price;
      });
    }
  }
}
